<form [formGroup]="form" (ngSubmit)="saveOrExecuteAction()">
  <div class="grid grid-cols-[auto_160px] gap-20">
    <mat-form-field>
      <mat-label>Company</mat-label>
      <input trimInput matInput formControlName="companyName" />
      @if (companyName.hasError('required')) {
        <mat-error>
          Company Name is <strong>{{ getErrorMessage(companyName.errors) }}</strong>
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>Country</mat-label>
      <mat-select formControlName="country" (selectionChange)="clearStateAndCity(countryName.value)" #countryName>
        @for (country of countries; track country) {
          <mat-option [value]="country.stateName">
            {{ country.abbreviation }}
          </mat-option>
        }
      </mat-select>
      @if (country.hasError('required')) {
        <mat-error>
          Country is <strong>{{ getErrorMessage(country.errors) }}</strong>
        </mat-error>
      }
    </mat-form-field>
  </div>

  <div class="grid grid-cols-[160px_auto_160px] gap-20">
    <mat-form-field>
      <mat-label>{{ !country?.value || country?.value === 'Australia' ? 'ABN' : 'NZBN' }}</mat-label>
      <input
        [trimInput]="country.value === 'New Zealand'"
        matInput
        formControlName="abn"
        (focusout)="adjustFormatOfAbn()" />
      @if (abn.hasError('required')) {
        <mat-error>
          {{ !country?.value || country?.value === 'Australia' ? 'ABN' : 'NZBN' }} is
          <strong>{{ getErrorMessage(abn.errors) }}</strong>
        </mat-error>
      }
      @if (abn.hasError('invalidABN') && !abn.hasError('required') && !abn.hasError('duplicateAbn')) {
        <mat-error>
          {{ getErrorMessage(abn.errors) }}
        </mat-error>
      }
      @if (abn.hasError('duplicateAbn')) {
        <mat-error>{{ getErrorMessage(abn.errors) }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Email</mat-label>
      <input trimInput matInput formControlName="email" />
      @if (email.hasError('required')) {
        <mat-error>
          Email is <strong>{{ getErrorMessage(email.errors) }}</strong>
        </mat-error>
      }
      @if (!email.valid && !email.hasError('required')) {
        <mat-error> Please enter a valid email address </mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>Contact</mat-label>
      <input matInput formControlName="phone" />
      @if (phone.touched && phone.hasError('phoneInvalid')) {
        <mat-error> {{ getErrorMessage(phone.errors) }} </mat-error>
      }
    </mat-form-field>
  </div>

  <div class="grid grid-cols-2 gap-20">
    <mat-form-field>
      <mat-label>Address</mat-label>
      <input trimInput matInput formControlName="addressLine1" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Address 2</mat-label>
      <input trimInput matInput formControlName="addressLine2" />
    </mat-form-field>
  </div>

  <div
    class="grid"
    [ngClass]="!country.value ? 'grid-cols-[auto_160px] gap-20' : 'grid-cols-[auto_160px_160px] gap-[23px]'">
    <mat-form-field>
      <mat-label>Suburb / Town</mat-label>
      <input trimInput matInput formControlName="suburb" />
    </mat-form-field>
    @if (country.value === 'Australia') {
      <mat-form-field>
        <mat-label>State</mat-label>
        <mat-select formControlName="state">
          @for (state of states; track state) {
            <mat-option [value]="state.abbreviation">
              {{ state.abbreviation }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (country.value === 'New Zealand') {
      <mat-form-field>
        <mat-label>City</mat-label>
        <input trimInput matInput formControlName="city" />
      </mat-form-field>
    }
    <mat-form-field>
      <mat-label>Postcode</mat-label>
      <input trimInput matInput formControlName="postCode" />
    </mat-form-field>
  </div>
  <div class="grid grid-cols-3 gap-x-20">
    <mat-form-field>
      <mat-label>BSB</mat-label>
      <input trimInput matInput formControlName="bsb" appNumbersOnly maxlength="6" />
      @if (bsb.hasError('required')) {
        <mat-error>
          BSB is <strong>{{ getErrorMessage(bsb.errors) }}</strong>
        </mat-error>
      }
      @if (bsb.hasError('exactNumCharactersInvalid')) {
        <mat-error>
          {{ getErrorMessage(bsb.errors) }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Account Number</mat-label>
      <input trimInput matInput formControlName="accountNumber" appNumbersOnly maxlength="9" />
      @if (accountNumber.hasError('required')) {
        <mat-error>
          Account Number is <strong>{{ getErrorMessage(accountNumber.errors) }}</strong>
        </mat-error>
      }
      @if (accountNumber.hasError('minlength')) {
        <mat-error>
          {{ getErrorMessage(accountNumber.errors) }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Account Name</mat-label>
      <input trimInput matInput formControlName="accountName" appAlphanumeric allowSpaces maxlength="32" />
      @if (accountName.hasError('required')) {
        <mat-error>
          Account Name is <strong>{{ getErrorMessage(accountName.errors) }}</strong>
        </mat-error>
      }
    </mat-form-field>
  </div>
</form>
